const cookieKey = 'career_traffic_src';

const cookieConfig = {
  maxAge: 60 * 60 * 24 * 365,
  sameSite: 'lax',
  secure: ['production', 'staging'].includes(process.env.NODE_ENV),
  path: '/',
};

const trafficParameters = [
  {
    key: 'utm_source',
    label: 'ga_source',
    required: true,
  },
  {
    key: 'utm_medium',
    label: 'ga_medium',
    required: false,
  },
  {
    key: 'utm_campaign',
    label: 'ga_campaign',
    required: false,
  },
  {
    key: 'utm_content',
    label: 'ga_content',
    required: false,
  },
  {
    key: 'utm_term',
    label: 'ga_keyword',
    required: false,
  },
];

function getParameterByName(url, name) {
  // eslint-disable-next-line
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(url);

  return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
}

function getKeywords(source) {
  if (source === '' || source === '(direct)') return '';

  const searchEngines =
    'daum:q eniro:search_word naver:query pchome:q images.google:q google:q yahoo:p yahoo:q msn:q bing:q aol:query aol:q lycos:q lycos:query ask:q cnn:query virgilio:qs baidu:wd baidu:word alice:qs yandex:text najdi:q seznam:q rakuten:qt biglobe:q goo.ne:MT search.smt.docomo:MT onet:qt onet:q kvasir:q terra:query rambler:query conduit:q babylon:q search-results:q avg:q comcast:q incredimail:q startsiden:q go.mail.ru:q centrum.cz:q 360.cn:q sogou:query tut.by:query globo:q ukr:q so.com:q haosou.com:q auone:q'.split(
      ' '
    );
  for (let i = 0; i < searchEngines.length; i++) {
    const val = searchEngines[i].split(':');
    const name = val[0];
    const queryParameter = val[1];
    if (source.includes(name)) {
      if (getParameterByName(source, queryParameter) !== '') {
        return getParameterByName(source, queryParameter);
      }
    }
  }

  const google = new RegExp(
    '^https?://(www.)?google(.com?)?(.[a-z]{2}t?)?/?$',
    'i'
  );

  const yahoo = new RegExp('^https?://(r.)?search.yahoo.com/?[^?]*$', 'i');

  const bing = new RegExp('^https?://(www.)?bing.com/?$', 'i');
  if (google.test(source) || yahoo.test(source) || bing.test(source)) {
    return '(not provided)';
  }

  return '';
}

function getMedium(cookieObject) {
  if (cookieObject.ga_medium !== '') return cookieObject.ga_medium;

  if (cookieObject.ga_gclid !== '') return 'cpc';

  if (cookieObject.ga_source === '') return '';

  if (cookieObject.ga_source === '(direct)') return '(none)';

  if (cookieObject.ga_keyword !== '') return 'organic';

  return 'referral';
}

function getHostname(url) {
  const re = new RegExp('^(https://|http://)?([^/?:#]+)');
  const match = re.exec(url)[2];
  if (match !== null) {
    return match;
  }
  return '';
}

export default defineNuxtPlugin(() => {
  let cookieObject = {};
  cookieObject.ga_gclid = getParameterByName(document.location.href, 'gclid');

  let ignoreUtmParameters = false;
  for (let i = 0; i < trafficParameters.length; i++) {
    const value = getParameterByName(
      document.location.href,
      trafficParameters[i].key
    );
    if (trafficParameters[i].required && value === '') {
      ignoreUtmParameters = true;
      for (let j = 0; j < trafficParameters.length; j++) {
        cookieObject[trafficParameters[j].label] = '';
      }
      break;
    }
    cookieObject[trafficParameters[i].label] = value;
  }

  const trafficSourceCookie = useCookie(cookieKey, cookieConfig);

  if (cookieObject.ga_gclid !== '' && cookieObject.ga_source === '') {
    cookieObject.ga_source = 'google';
  } else if (ignoreUtmParameters) {
    if (document.referrer.includes(document.location.host)) return;

    if (trafficSourceCookie?.value !== null && document.referrer === '') return;

    if (
      document.referrer !== '' &&
      document.referrer.includes('linkedin.com')
    ) {
      return;
    }

    cookieObject.ga_source =
      document.referrer !== '' ? document.referrer : '(direct)';
  }

  cookieObject.ga_keyword =
    cookieObject.ga_keyword === ''
      ? getKeywords(cookieObject.ga_source)
      : cookieObject.ga_keyword;
  cookieObject.ga_medium = getMedium(cookieObject);
  cookieObject.ga_landing_page = document.location.href;
  cookieObject.ga_source = getHostname(cookieObject.ga_source);

  if (cookieObject.ga_source !== '') {
    trafficSourceCookie.value = cookieObject;
  }
});
